module.exports = __webpack_public_path__ + "static/img/03.88fda54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/k_mueller/03.jpg
// module id = 410
// module chunks = 1